export default function(errMessage, isLoading) {
  return '' === errMessage && false === isLoading
}



// WEBPACK FOOTER //
// ./src/utils/shouldRender.js